const config = {  
  API_BASE_URL: "https://lovebigdev.azurewebsites.net/admin",

  //Development only
  //API_BASE_URL:  "https://localhost:44370",
};

export default config;
